import Vue from 'vue';
import WorkCalendar from '@/components/global_components/calendar/WorkCalendar';
import WorkRadio from '@/components/global_components/forms/WorkRadio';
import WorkTreeview from '@/components/global_components/forms/WorkTreeview';
import WorkCurrencyTextField from '@/components/global_components/forms/text_fields/WorkCurrencyTextField';
import WorkPercentageTextField from '@/components/global_components/forms/text_fields/WorkPercentageTextField';
import WorkTextField from '@/components/global_components/forms/WorkTextField';
import WorkReadOnlyTextfield from '@/components/global_components/forms/WorkReadOnlyTextField';
import WorkBreadcrumbs from '@/components/global_components/forms/WorkBreadcrumbs';
import WorkDecimalTextField from '@/components/global_components/forms/text_fields/WorkDecimalTextField';
import WorkNumberTextField from '@/components/global_components/forms/text_fields/WorkNumberTextField';
import WorkCheckbox from '@/components/global_components/forms/WorkCheckbox';
import WorkSelect from '@/components/global_components/forms/WorkSelect';
import WorkSwitch from '@/components/global_components/forms/WorkSwitch';
import WorkTextArea from '@/components/global_components/forms/WorkTextArea';
import WorkDateField from '@/components/global_components/forms/WorkDateField';
import WorkDateYearField from '@/components/global_components/forms/WorkDateYearField';
import WorkTimeField from '@/components/global_components/forms/WorkTimeField';
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
import WorkAutocompleteLazy from '@/components/base_components/WorkAutocompleteLazy';
import WorkOrderRelationInput from '@/components/global_components/forms/WorkOrderRelationInput';
import WorkToggleableContent from '@/components/global_components/forms/WorkToggleableContent';
import WorkList from '@/components/global_components/list/WorkList';
import WorkListItem from '@/components/global_components/list/WorkListItem';
import WorkProgressBar from '@/components/global_components/progressbar/WorkProgressBar';
import WorkUploadZone from '@/components/global_components/forms/WorkUploadZone';
import WorkDataTable from '@/components/base_components/tables/WorkDataTable';
import WorkTemporalAmountField from '@/components/global_components/forms/WorkTemporalAmountField';

Vue.component('WCalendar', WorkCalendar);
Vue.component('WRadio', WorkRadio);
Vue.component('WTreeview', WorkTreeview);
Vue.component('WCurrencyField', WorkCurrencyTextField);
Vue.component('WPercentageField', WorkPercentageTextField);
Vue.component('WTextField', WorkTextField);
Vue.component('WReadOnlyTextField', WorkReadOnlyTextfield);
Vue.component('WBreadcrumbs', WorkBreadcrumbs);
Vue.component('WDecimalTextField', WorkDecimalTextField)
Vue.component('WNumberTextField', WorkNumberTextField);
Vue.component('WCheckbox', WorkCheckbox);
Vue.component('WSelect', WorkSelect);
Vue.component('WSwitch', WorkSwitch);
Vue.component('WTextArea', WorkTextArea);
Vue.component('WDateField', WorkDateField);
Vue.component('WDateYearField', WorkDateYearField);
Vue.component('WTimeField', WorkTimeField);
Vue.component('WAutocomplete', WorkAutocomplete);
Vue.component('WAutocompleteLazy', WorkAutocompleteLazy);
Vue.component('WOrderRelationInput', WorkOrderRelationInput);
Vue.component('WToggleableContent', WorkToggleableContent);
Vue.component('WList', WorkList);
Vue.component('WListItem', WorkListItem);
Vue.component('WProgressBar', WorkProgressBar);
Vue.component('WUploadZone', WorkUploadZone);
Vue.component('WDataTable', WorkDataTable);
Vue.component('WTimeAmountField', WorkTemporalAmountField);